export default "__VITE_ASSET__DOy0WvnT__"